function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    var prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (var i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

export { shallowCompare };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/shallow-compare.mjs
// module id = JtcT
// module chunks = 0